import apiClient from "../../client/apiClient"

export type ActivityType =
  | "PAGE_VIEW"
  | "VIEW"
  | "CREATE"
  | "UPDATE"
  | "DELETE"
  | "LOGIN"
  | "LOGOUT"
  | "ACTION"

export type ActivityChange = {
  // Collection the field lives on, e.g. "Admission".
  record?: string
  field: string
  from: string
  to: string
}

export type ActivityLogItem = {
  _id: string
  at: string
  type: ActivityType
  label: string
  user: string | null
  userName: string
  userRole: string
  branch?: { _id: string; name: string; campusNo?: number } | null
  entityType?: string | null
  entityId?: string | null
  entityLabel?: string
  // Set on rows about a Student record: the enrollment its profile page is
  // keyed by.
  enrollmentId?: string
  page?: string
  summary?: string
  changes?: ActivityChange[]
  changesTruncated?: boolean
  path?: string
  statusCode?: number | null
  outcome: "success" | "denied" | "failed"
  ip?: string
  source: "live" | "backfill"
}

export type ActivityLogParams = {
  page?: number
  limit?: number
  user?: string
  type?: string
  label?: string
  // ISO timestamps
  from?: string
  to?: string
  q?: string
}

export type ActivityLogFilters = {
  labels: string[]
  types: ActivityType[]
  users: { _id: string; name: string; role: string }[]
}

const BASE = "/activity"

export const listActivityLogs = async (
  params: ActivityLogParams
): Promise<{
  success: boolean
  data: ActivityLogItem[]
  page: number
  limit: number
  hasMore: boolean
}> => {
  const res = await apiClient({ method: "GET", url: BASE, params })
  return res.data
}

export const getActivityLogFilters = async (): Promise<{
  success: boolean
  data: ActivityLogFilters
}> => {
  const res = await apiClient({ method: "GET", url: `${BASE}/filters` })
  return res.data
}

// Fire-and-forget: the caller never waits on this and a failure must never
// surface to the user -- it is bookkeeping, not part of what they are doing.
// `recordId`: the record a page was opened for, when the URL doesn't carry it.
export const reportPageView = (path: string, title: string, recordId?: string): void => {
  apiClient({
    method: "POST",
    url: `${BASE}/page-view`,
    data: { path, title, ...(recordId ? { recordId } : {}) },
  }).catch(
    () => {
      /* ignore */
    }
  )
}
